'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ENGAGEMENT_ELEMENTS = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _uiInternalLink = require('@spp/ui-internal-link');

var _uiInternalLink2 = _interopRequireDefault(_uiInternalLink);

var _svg = require('../svg');

var _props2 = require('../props');

var _MastheadExtensionSubscriptionButtons = require('../MastheadExtensionSubscriptionButtons');

var _MastheadExtensionSubscriptionButtons2 = _interopRequireDefault(_MastheadExtensionSubscriptionButtons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ENGAGEMENT_ELEMENTS = exports.ENGAGEMENT_ELEMENTS = {
    SUBMENU_SECTION: 'Masthead_SubmenuSection',
    SUBMENU_SUBSECTION: 'Masthead_SubmenuSubsection'
}; /* eslint-disable import/no-named-as-default */


var sectionClick = function sectionClick(engagement, name) {
    return function (event) {
        engagement({
            elementIdentifier: ENGAGEMENT_ELEMENTS.SUBMENU_SECTION,
            meta: { name: name, event: event }
        });
    };
};

var subsectionClick = function subsectionClick(engagement, name) {
    return function (event) {
        engagement({
            elementIdentifier: ENGAGEMENT_ELEMENTS.SUBMENU_SUBSECTION,
            meta: { name: name, event: event }
        });
    };
};

var given = function given(sectionPath) {
    return {
        isThisAnActive: function isThisAnActive(subSection) {
            return subSection.path && new RegExp(subSection.path).test(sectionPath);
        }
    };
};

var MastheadExtensionSectionView = function (_Component) {
    (0, _inherits3.default)(MastheadExtensionSectionView, _Component);

    function MastheadExtensionSectionView(props) {
        (0, _classCallCheck3.default)(this, MastheadExtensionSectionView);

        var _this = (0, _possibleConstructorReturn3.default)(this, (MastheadExtensionSectionView.__proto__ || (0, _getPrototypeOf2.default)(MastheadExtensionSectionView)).call(this, props));

        _this.generateSubSectionsList = function (section, theme, isDropdownOpen, engagement, sectionPath) {
            var subsectionsContainerClass = isDropdownOpen ? 'subsectionsContainer-isOpen' : 'subsectionsContainer';

            return _react2.default.createElement(
                'div',
                { className: theme[subsectionsContainerClass] },
                _react2.default.createElement(
                    'ul',
                    { className: theme.subsections },
                    section.subSections.map(function (subSection) {
                        var _classNames;

                        return _react2.default.createElement(
                            'li',
                            {
                                key: subSection.url,
                                className: (0, _classnames2.default)((_classNames = {}, (0, _defineProperty3.default)(_classNames, theme.subsectionItem, true), (0, _defineProperty3.default)(_classNames, theme.active, given(sectionPath).isThisAnActive(subSection)), _classNames))
                            },
                            _react2.default.createElement(
                                _uiInternalLink2.default,
                                {
                                    link: subSection.url,
                                    className: theme.subsectionLink,
                                    onClick: subsectionClick(engagement, subSection.name),
                                    enableSinglePage: true
                                },
                                subSection.name
                            )
                        );
                    })
                )
            );
        };

        _this.openDropdown = function () {
            _this.setState({
                isDropdownOpen: !_this.state.isDropdownOpen
            });
        };

        _this.generateSubjectElement = function (theme, chevronSvg, isDropdownOpen, sectionsDropdownLabel) {
            var triggerClass = isDropdownOpen ? theme['dropdownTrigger-isOpen'] : theme.dropdownTrigger;

            return _react2.default.createElement(
                'button',
                {
                    className: triggerClass,
                    'aria-haspopup': 'true',
                    onClick: _this.openDropdown
                },
                sectionsDropdownLabel,
                _react2.default.createElement(_svg.ChevronDownMastheadExtensionSvg, {
                    icon: chevronSvg,
                    title: chevronSvg.title
                })
            );
        };

        _this.renderSectionHeader = function (section, theme, engagement) {
            return section.url ? _react2.default.createElement(
                _uiInternalLink2.default,
                {
                    link: section.url,
                    className: theme.sectionLabel,
                    onClick: sectionClick(engagement, section.name),
                    enableSinglePage: true
                },
                section.name
            ) : _react2.default.createElement(
                'span',
                { className: theme.sectionLabel },
                section.name
            );
        };

        _this.state = {
            isDropdownOpen: props.isDropdownOpen
        };
        return _this;
    }

    (0, _createClass3.default)(MastheadExtensionSectionView, [{
        key: 'render',
        value: function render() {
            var subjectElement = void 0;
            var subSectionsList = void 0;

            var _props = this.props,
                _props$mastheadExtens = _props.mastheadExtension,
                chevronSvg = _props$mastheadExtens.svg.chevron,
                labels = _props$mastheadExtens.labels,
                loginFirst = _props$mastheadExtens.loginFirst,
                section = _props.section,
                theme = _props.theme,
                attributes = _props.attributes,
                engagement = _props.engagement,
                sectionPath = _props.sectionPath;

            var mastheadExtension = this.props.mastheadExtension;

            if (section.subSections) {
                subjectElement = this.generateSubjectElement(theme, chevronSvg, this.state.isDropdownOpen, labels.sectionsDropdown, engagement);
                subSectionsList = this.generateSubSectionsList(section, theme, this.state.isDropdownOpen, engagement, sectionPath);
            }

            return _react2.default.createElement(
                'div',
                { className: theme.sectionLinks },
                _react2.default.createElement(
                    'div',
                    { className: theme.sectionLabelContainer },
                    this.renderSectionHeader(section, theme, engagement)
                ),
                subjectElement,
                subSectionsList,
                _react2.default.createElement(_MastheadExtensionSubscriptionButtons2.default, {
                    theme: theme,
                    mastheadExtension: mastheadExtension,
                    attributes: attributes,
                    engagement: engagement,
                    loginFirst: loginFirst
                })
            );
        }
    }]);
    return MastheadExtensionSectionView;
}(_react.Component);

exports.default = MastheadExtensionSectionView;


if (process.env.NODE_ENV !== 'production') {
    MastheadExtensionSectionView.propTypes = {
        attributes: _propTypes2.default.func,
        engagement: _propTypes2.default.func,
        isDropdownOpen: _propTypes2.default.bool,
        mastheadExtension: _propTypes2.default.shape(_props2.mastheadExtensionProps).isRequired,
        section: _propTypes2.default.shape(_props2.mastheadExtensionHeaderProps).isRequired,
        sectionPath: _propTypes2.default.string,
        theme: _propTypes2.default.shape({
            dropdownTrigger: _propTypes2.default.string,
            'dropdownTrigger-isOpen': _propTypes2.default.string,
            isOpen: _propTypes2.default.string,
            sectionLabel: _propTypes2.default.string,
            sectionLabelContainer: _propTypes2.default.string,
            sectionLinks: _propTypes2.default.string,
            subsections: _propTypes2.default.string,
            subsectionsContainer: _propTypes2.default.string,
            'subsectionsContainer-isOpen': _propTypes2.default.string,
            subsectionItem: _propTypes2.default.string,
            subsectionLink: _propTypes2.default.string
        })
    };
}

MastheadExtensionSectionView.defaultProps = {
    attributes: function attributes() {},
    engagement: function engagement() {
        return _promise2.default.resolve();
    },
    isDropdownOpen: false,
    sectionName: undefined,
    sectionPath: undefined,
    theme: {}
};
//# sourceMappingURL=MastheadExtensionSectionView.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-navigation/lib/cjs/components/MastheadExtensionSectionView/MastheadExtensionSectionView.js
 ** module id = 324
 ** module chunks = 0
 **/